import { render, staticRenderFns } from "./generalListParameter.vue?vue&type=template&id=9df50ef6"
import script from "./generalListParameter.vue?vue&type=script&lang=js"
export * from "./generalListParameter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports